import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
    >
      <G clipPath="url(#clip0_3912_118)">
        <Path
          d="M17.572.429H.429v17.143h17.143V.429zM8.143 4.714h5.142M8.143 9h5.142m-5.142 4.286h5.142"
          stroke="#434BFF"
          strokeWidth={1.2}
          strokeLinecap="square"
        />
        <Path fill="#434BFF" d="M3.42871 4.28564H4.285853V5.142783H3.42871z" />
        <Path fill="#434BFF" d="M3.42871 8.57129H4.285853V9.428433H3.42871z" />
        <Path fill="#434BFF" d="M3.42871 12.8569H4.285853V13.714043H3.42871z" />
      </G>
      <Defs>
        <ClipPath id="clip0_3912_118">
          <Path fill="#fff" d="M0 0H18V18H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
